<div>
    <h3 *ngIf="scheduleFilesAttachment.length == 0">
        Chưa có tài liệu nào
    </h3>
    <div>        
        <table *ngIf="scheduleFilesAttachment.length > 0" class="table table-bordered">            
            <thead>
                <tr>
                    <td width="5%">STT</td>
                    <td style="width: 30%">Tên tài liệu</td>
                    <td>Số ký hiệu</td>
                    <td>Ngày phát hành</td>
                    <td>Trích yếu</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>                
                <ng-container *ngFor="let objectType of attachmentMaster">
                    <tr *ngIf="objectType.data.length > 0">
                        <th colspan="5">
                            {{objectType.title}}
                        </th>
                    </tr>
                    <tr *ngFor="let item of objectType.data; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>                
                            <a href="{{ item.filePath }}" target="_blank">{{ item.fileName }}</a>
                        </td>
                        <td>{{ item.notationNumber }}</td>
                        <td>{{ item.releaseDate | date: "dd/MM/yyyy hh:mm a" }}</td>
                        <td>{{ item.quote }}</td>
                        <td ngbTooltip="Tải xuống"><a href="{{getDownloadPath(item.filePath)}}"><i class="fas fa-file-download"></i></a></td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>